<script setup>
import { Button } from '~/components/shadcn/ui/button'

const props = defineProps({
	error: {
		type: Object,
	}
})

console.log('[ERROR-DEBUG] Error:', props.error)

const globalStore = useGlobalStore()

const errorContent = computed(() => {
	if (props.error.statusCode === 404) {
		return {
			title: 'Ой! Что-то пошло не так...',
			description: 'Страница, которую вы ищете, не найдена. Она может быть удалена, перемещена или, возможно, в адресе есть небольшая опечатка.',
			img: '/img/img_error_404.png',
		}
	}
	return {
		title: 'Ой! Что-то пошло не так...',
		description: 'Похоже, на нашем сервере возникла проблема. Мы уже работаем над ее исправлением! Пожалуйста, попробуйте обновить страницу позже.',
		img: null/* '/img/img_error_500.png' */,
	}
})

</script>

<template>
	<div class="bg-stroke min-w-screen h-screen px-5 py-5 md:py-10 relative">
		<div class="container mx-auto h-full flex flex-col justify-between ">
			<!-- <img src="/img/ys_footer_logo.svg" alt="Yourservice" class="mx-auto max-h-[34px]"> -->
			<NuxtLink to="/" class="block">
				<img :src="globalStore.global?.logo || '/img/logo_n.png'" :alt="globalStore.global?.descriptor" class="max-w-[80px] w-auto" />
			</NuxtLink>

			<div class="grid md:grid-cols-2 gap-10 items-center py-12 grow">
				<div class="max-w-[540px] order-2 md:order-1 text-center md:text-left">
					<h1 class="text-7xl font-bold text-destructive">{{ error.statusCode }}</h1>
					<p class="mt-4 text-2xl font-bold">{{ errorContent.title }}</p>
					<p class="mt-4 text-gray-500">{{ errorContent.description }}</p>
					<Button class="w-full md:w-fit mt-4" variant="primary" size="lg" as-child>
						<NuxtLink to="/">Вернуться на главную</NuxtLink>
					</Button>
				</div>
				<img class="order-1 md:order-2" :src="errorContent.img" alt="">
			</div>

		</div>
	</div>


</template>
